import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { SubscriptionDto } from '@/Domain/api/Subscription/dto/Subscription.dto';
import { SubscriptionDraftDto } from '@/Domain/api/Subscription/dto/SubscriptionDraft.dto';
import { SubscriptionManageDto } from '@/Domain/api/Subscription/dto/SubscriptionManage.dto';
import { SubscriptionPlansDto } from '@/Domain/api/Subscription/dto/SubscriptionPlans.dto';
import { SubscriptionUpdateDto } from '@/Domain/api/Subscription/dto/SubscriptionUpdate.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class SubscriptionApi {
  static list = (): Promise<SubscriptionPlansDto> =>
    httpClient.get(Endpoint.subscription.list).then(ApiMapper.toResponseData);

  static get = (): Promise<SubscriptionDto> =>
    httpClient.get(Endpoint.subscription.get).then(ApiMapper.toResponseData);

  static manage = (): Promise<SubscriptionManageDto> =>
    httpClient.post(Endpoint.subscription.manage).then(ApiMapper.toResponseData);

  static cancel = (status: 'activate' | 'cancel', cancellationReason?: string): Promise<void> =>
    httpClient.post(Endpoint.subscription.cancel, {
      status,
      cancellation_reason: cancellationReason,
    });

  static update = (
    priceId: string,
    source?: string,
    promotionCode?: string,
  ): Promise<SubscriptionUpdateDto | void> =>
    httpClient
      .post(Endpoint.subscription.update, {
        price_id: priceId,
        source,
        promotion_code: promotionCode,
      })
      .then(ApiMapper.toResponseData);

  static draft = (priceId: string, signal?: AbortSignal): Promise<SubscriptionDraftDto> =>
    httpClient
      .post(Endpoint.subscription.draft, { price_id: priceId }, { signal })
      .then(ApiMapper.toResponseData);
}
